import { useLocation } from "react-router-dom";

export default function Preview() {
  const location = useLocation();

  const { state } = location;

  console.log(state);

  return (
    <div className="bg-[#E9FAF2] p-5 mt-6">
      <div>
        <div className="mb-4 flex items-center justify-between">
          <p className="font-bold text-[#1A222F] dark:text-white mb-2 text-[1.31rem]">
            {state.name}
          </p>

          <img src={state.img} alt = "drug" />
        </div>

        <div className="mb-4">
          <p className="text-sm">{state.description}</p>
        </div>

        <div className="mb-4">
          <p className="font-medium mb-2">
            Brand Name
          </p>

          <p className="text-sm">
            {state.brandName}
          </p>
        </div>

        <div className="mb-4">
          <p className="font-medium mb-2">
            Administration
          </p>

          <p className="text-sm">
            {state.administration}
          </p>
        </div>
      </div>
    </div>
  );
}
